import React from 'react';
import UnitSlideShowCard from '../UnitSlideShowCard/UnitSlideShowCard';
import type { SlideShow } from '../UnitSlideShowCard/UnitSlideShowCardTypes';

interface UnitSlideShowCardsProps {
  overviewColor: string;
  programId: number;
  slideShows: SlideShow[];
  stafferId?: number;
  unitId: number;
}

const UnitSlideShowCards = ({ overviewColor, programId, slideShows, stafferId, unitId }: UnitSlideShowCardsProps) => (
  <div className="tw-flex tw-flex-col tw-px-6">
    {slideShows.map(ss => (
      <UnitSlideShowCard
        key={ss.id}
        overviewColor={overviewColor}
        programId={programId}
        slideShow={ss}
        stafferId={stafferId}
        unitId={unitId}
      />
    ))}
  </div>
);

export default UnitSlideShowCards;
